import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class TimeZonePricesService {

    private baseObject = Object();

    constructor() {
        this.baseObject = this.populateBasePricing();
    }

    populateBasePricing(): object
    {
        let finalObject = [];
        finalObject[0] = { id: 1, name: "Practice Annual", description: "Yearly Practice Subscription", stripe_reference: "annual_practice", amount: null, type: "base", frequency: "annualy", created_at: null, updated_ar: null, currency: null }
        finalObject[1] = { id: 2, name: "Practice Monthly", description: "Monthly Practice Subscription", stripe_reference: "monthly_practice", amount: null, type: "base", frequency: "monthly", created_at: null, updated_ar: null, currency: null }
        finalObject[2] = { id: 3, name: "Individual Annual", description: "Individual Annual Subscription", stripe_reference: "annual_single", amount: null, type: "base", frequency: "annualy", created_at: null, updated_ar: null, currency: null }
        finalObject[3] = { id: 4, name: "Individual Monthly", description: "Individual Monthly Subscription", stripe_reference: "monthly_single", amount: null, type: "base", frequency: "monthly", created_at: null, updated_ar: null, currency: null }
        finalObject[4] = { id: 5, name: "Seats Annual", description: "This is the plan for adding additional seats on an annual basis", stripe_reference: "annual_seats", amount: null, type: "extra", frequency: "annualy", created_at: null, updated_ar: null, currency: null }
        finalObject[5] = { id: 6, name: "Seats Monthly", description: "This is the plan for adding additional seats on a montly basis", stripe_reference: "monthly_seats", amount: null, type: "extra", frequency: "monthly", created_at: null, updated_ar: null, currency: null }
        return finalObject;
    }

    public getUSATimeZoneZonePrice()
    {
        this.baseObject[0].amount = 3550; this.baseObject[0].currency = '$';
        this.baseObject[0].stripe_reference = environment.stripePrices.practiceAnnual.usd;
        this.baseObject[1].amount = 355; this.baseObject[1].currency = '$';
        this.baseObject[1].stripe_reference = environment.stripePrices.practiceMonthly.usd;
        this.baseObject[2].amount = 775; this.baseObject[2].currency = '$';
        this.baseObject[2].stripe_reference = environment.stripePrices.individualAnnual.usd;
        this.baseObject[3].amount = 85; this.baseObject[3].currency = '$';
        this.baseObject[3].stripe_reference = environment.stripePrices.individualMonthly.usd;
        this.baseObject[4].amount = 152; this.baseObject[4].currency = '$';
        return this.baseObject;
    }

    public getEUTimeZonePrice()
    {
        this.baseObject[0].amount = 3210; this.baseObject[0].currency = '€';
        this.baseObject[0].stripe_reference = environment.stripePrices.practiceAnnual.eur;
        this.baseObject[1].amount = 320; this.baseObject[1].currency = '€';
        this.baseObject[1].stripe_reference = environment.stripePrices.practiceMonthly.eur;
        this.baseObject[2].amount = 695; this.baseObject[2].currency = '€';
        this.baseObject[2].stripe_reference = environment.stripePrices.individualAnnual.eur;
        this.baseObject[3].amount = 79; this.baseObject[3].currency = '€';
        this.baseObject[3].stripe_reference = environment.stripePrices.individualMonthly.eur;
        this.baseObject[4].amount = 140; this.baseObject[4].currency = '€';
        return this.baseObject;
    }

    public getHongKongTimeZonePrice()
    {
        this.baseObject[0].amount = 26925; this.baseObject[0].currency = 'HK$';
        this.baseObject[0].stripe_reference = environment.stripePrices.practiceAnnual.hkd;
        this.baseObject[1].amount = 2690; this.baseObject[1].currency = 'HK$';
        this.baseObject[1].stripe_reference = environment.stripePrices.practiceMonthly.hkd;
        this.baseObject[2].amount = 5840; this.baseObject[2].currency = 'HK$';
        this.baseObject[2].stripe_reference = environment.stripePrices.individualAnnual.hkd;
        this.baseObject[3].amount = 630; this.baseObject[3].currency = 'HK$';
        this.baseObject[3].stripe_reference = environment.stripePrices.individualMonthly.hkd;
        this.baseObject[4].amount = 1188; this.baseObject[4].currency = 'HK$';
        return this.baseObject;
    }

    public getAucklandTimeZonePrice()
    {
        this.baseObject[0].amount = 5960; this.baseObject[0].currency = 'NZ$';
        this.baseObject[0].stripe_reference = environment.stripePrices.practiceAnnual.nzd;
        this.baseObject[1].amount = 595; this.baseObject[1].currency = 'NZ$';
        this.baseObject[1].stripe_reference = environment.stripePrices.practiceMonthly.nzd;
        this.baseObject[2].amount = 1250; this.baseObject[2].currency = 'NZ$';
        this.baseObject[2].stripe_reference = environment.stripePrices.individualAnnual.nzd;
        this.baseObject[3].amount = 139; this.baseObject[3].currency = 'NZ$';
        this.baseObject[3].stripe_reference = environment.stripePrices.individualMonthly.nzd;
        this.baseObject[4].amount = 249; this.baseObject[4].currency = 'NZ$';
        return this.baseObject;
    }

    public getAustraliaTimeZonePrice()
    {
        this.baseObject[0].amount = 5385; this.baseObject[0].currency = 'AUD$';
        this.baseObject[0].stripe_reference = environment.stripePrices.practiceAnnual.aud;
        this.baseObject[1].amount = 540; this.baseObject[1].currency = 'AUD$';
        this.baseObject[1].stripe_reference = environment.stripePrices.practiceMonthly.aud;
        this.baseObject[2].amount = 1150; this.baseObject[2].currency = 'AUD$';
        this.baseObject[2].stripe_reference = environment.stripePrices.individualAnnual.aud;
        this.baseObject[3].amount = 125; this.baseObject[3].currency = 'AUD$';
        this.baseObject[3].stripe_reference = environment.stripePrices.individualMonthly.aud;
        this.baseObject[4].amount = 228; this.baseObject[4].currency = 'AUD$';
        return this.baseObject;
    }

    public getCanadaTimeZonePrice()
    {
        this.baseObject[0].amount = 4755; this.baseObject[0].currency = 'C$';
        this.baseObject[0].stripe_reference = environment.stripePrices.practiceAnnual.cad;
        this.baseObject[1].amount = 475; this.baseObject[1].currency = 'C$';
        this.baseObject[1].stripe_reference = environment.stripePrices.practiceMonthly.cad;
        this.baseObject[2].amount = 1010; this.baseObject[2].currency = 'C$';
        this.baseObject[2].stripe_reference = environment.stripePrices.individualAnnual.cad;
        this.baseObject[3].amount = 109; this.baseObject[3].currency = 'C$';
        this.baseObject[3].stripe_reference = environment.stripePrices.individualMonthly.cad;
        this.baseObject[4].amount = 208; this.baseObject[4].currency = 'C$';
        return this.baseObject;
    }

    public getUAETimeZonePrice()
    {
        this.baseObject[0].amount = 12605; this.baseObject[0].currency = 'AED';
        this.baseObject[0].stripe_reference = environment.stripePrices.practiceAnnual.aed;
        this.baseObject[1].amount = 1260; this.baseObject[1].currency = 'AED';
        this.baseObject[1].stripe_reference = environment.stripePrices.practiceMonthly.aed;
        this.baseObject[2].amount = 2760; this.baseObject[2].currency = 'AED';
        this.baseObject[2].stripe_reference = environment.stripePrices.individualAnnual.aed;
        this.baseObject[3].amount = 300; this.baseObject[3].currency = 'AED';
        this.baseObject[3].stripe_reference = environment.stripePrices.individualMonthly.aed;
        this.baseObject[4].amount = 582; this.baseObject[4].currency = 'AED';
        return this.baseObject;
    }
}
